import "core-js/modules/es.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
export default {
  name: "emaliLog",
  mixins: [loadMoreList, serchSelect],
  data: function data() {
    return {
      pagingReqFn: "sendEmailLogData",
      pagingReqValue: "data",
      drawer: false,
      gameList: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    exportdata: function exportdata() {
      var _this2 = this;

      var Dynamic = [{
        label: "游戏",
        prop: "show_name"
      }, {
        label: "邮箱",
        prop: "email"
      }, {
        label: "IP",
        prop: "ip"
      }, {
        label: "操作时间",
        prop: "created_at"
      }];
      this.$api.sendEmailLogDataAll(this.paramsData).then(function (res) {
        if (res.code == 0) {
          res.data.map(function (i) {
            i.created_at = _this2.$times.timestampToTime(i.created_at);
          });

          _this2.$export.excel({
            columns: Dynamic,
            data: res.data,
            title: "邮箱发送日志"
          });
        }
      });
    }
  }
};